/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Published_UpdatedInputs */

const en_legal_published_updated = /** @type {((inputs: Legal_Published_UpdatedInputs) => LocalizedString) & { parts: (inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_Published_UpdatedInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Published , last updated `)
		}),
		{
			parts: /** @type {(inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Published " }, { type: "markup-standalone", name: "published", options: {}, attributes: {} }, { type: "text", value: ", last updated " }, { type: "markup-standalone", name: "updated", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_legal_published_updated = /** @type {((inputs: Legal_Published_UpdatedInputs) => LocalizedString) & { parts: (inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_Published_UpdatedInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`发布于 ，最近更新于 `)
		}),
		{
			parts: /** @type {(inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "发布于 " }, { type: "markup-standalone", name: "published", options: {}, attributes: {} }, { type: "text", value: "，最近更新于 " }, { type: "markup-standalone", name: "updated", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Published , last updated" |
*
* @param {Legal_Published_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const legal_published_updated = /** @type {((inputs?: Legal_Published_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Legal_Published_UpdatedInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Legal_Published_UpdatedInputs, { locale?: "en" | "zh" }, { published: { options: {}; attributes: {}; children: false }; updated: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Legal_Published_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_legal_published_updated(inputs)
			return en_legal_published_updated(inputs)
		}),
		{
			parts: /** @type {(inputs?: Legal_Published_UpdatedInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[] }} */ (zh_legal_published_updated).parts?.(inputs) ?? [{ type: "text", value: zh_legal_published_updated(inputs) }]
				return /** @type {{ parts?: (inputs: Legal_Published_UpdatedInputs) => import('../runtime.js').MessagePart[] }} */ (en_legal_published_updated).parts?.(inputs) ?? [{ type: "text", value: en_legal_published_updated(inputs) }]
			})
		}
	)
);